import { IconButton, IconButtonProps, ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useCallback } from 'react';
import { Link, To } from 'react-router-dom';
import { useToolbarActionMenu } from './ToolbarActionMenu';

interface Props extends IconButtonProps {
  to?: To;
  href?: string;
  target?: string;
}

export const LinkIconButton: React.FC<Props> = ({ to, color, size, children, ...props }) => {
  const menu = useToolbarActionMenu();
  const { onClick, title, disabled, href, target } = props;

  const handleMenuItemClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      onClick?.(event as React.MouseEvent<HTMLButtonElement>);
      menu?.closeMenu();
    },
    [onClick, menu],
  );

  if (menu) {
    const linkProps = to ? { component: Link, to } : href ? { component: 'a' as const, href, target } : {};
    return (
      <MenuItem
        {...linkProps}
        data-test-id={(props as Record<string, unknown>)['data-test-id']}
        title={title}
        onClick={handleMenuItemClick}
        disabled={disabled}
        sx={{
          ...(color === 'error' ? { color: 'error.main', '& .MuiListItemIcon-root': { color: 'inherit' } } : undefined),
        }}
      >
        <ListItemIcon>{children}</ListItemIcon>
        <ListItemText>{title ?? props['aria-label']}</ListItemText>
      </MenuItem>
    );
  }

  return to ? (
    <IconButton component={Link} to={to} color={color} size={size}>
      {children}
    </IconButton>
  ) : (
    <IconButton color={color} size={size} {...props}>
      {children}
    </IconButton>
  );
};
